var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgETree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 1.44772 0.447715 1 1 1H10C10.5523 1 11 1.44772 11 2V6C11 6.55228 10.5523 7 10 7H1C0.447715 7 0 6.55228 0 6V2Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0 0.447715 0.447715 0 1 0H4C4.55228 0 5 0.447715 5 1V6C5 6.55228 4.55228 7 4 7H1C0.447715 7 0 6.55228 0 6V1Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9C13 8.44772 13.4477 8 14 8H17C17.5523 8 18 8.44772 18 9V14C18 14.5523 17.5523 15 17 15H14C13.4477 15 13 14.5523 13 14V9Z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17C13 16.4477 13.4477 16 14 16H17C17.5523 16 18 16.4477 18 17V22C18 22.5523 17.5523 23 17 23H14C13.4477 23 13 22.5523 13 22V17Z",
    fill: "#FEFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7H6V24H5V7Z",
    fill: "#FEFEFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 19H13V20H6V19Z",
    fill: "#FEFEFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11H13V12H6V11Z",
    fill: "#FEFEFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13 18C13 17.4477 13.4477 17 14 17H23C23.5523 17 24 17.4477 24 18V22C24 22.5523 23.5523 23 23 23H14C13.4477 23 13 22.5523 13 22V18Z",
    fill: "#FEFEFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10C13 9.44772 13.4477 9 14 9H23C23.5523 9 24 9.44772 24 10V14C24 14.5523 23.5523 15 23 15H14C13.4477 15 13 14.5523 13 14V10Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgETree);
export default __webpack_public_path__ + "static/media/ETree.dc702d062e877b2d2f11ad6053b297e1.svg";
export { ForwardRef as ReactComponent };